module.exports = __webpack_public_path__ + "static/media/btn-class.0b80d93b.svg";